import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxIntuitiveArtIndicationButtonComponent } from '../rx-intuitive-art-indication-button/rx-intuitive-art-indication-button.component';
import { ArtTreatmentIntegrity, ArtTreatmentDefinition } from '../../../models';

@Component({
	selector: 'rx-intuitive-art-treatment-buttons',
	templateUrl: './rx-intuitive-art-treatment-buttons.component.html',
	styleUrls: ['./rx-intuitive-art-treatment-buttons.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { '[class.rx-intuitive-art-treatment-buttons--as-label]': 'asLabel' },
	imports: [CommonModule, RxIntuitiveArtIndicationButtonComponent]
})
export class RxIntuitiveArtTreatmentButtonsComponent {
	@Input() visibleIntegrities: ArtTreatmentIntegrity[] = [];
	@Input() selectedIntegrity?: ArtTreatmentIntegrity;
	@Input() enabledIntegrities: ArtTreatmentIntegrity[] = [];
	@Input() visibleDefinitions: ArtTreatmentDefinition[] = [];
	@Input() selectedDefinitions: ArtTreatmentDefinition[] = [];
	@Input() enabledDefinitions: ArtTreatmentDefinition[] = [];

	@Input() disabled = false;
	@Input() asLabel = false;
	@Input() hideIcon = false;
	@Input() omitIndicationRowMargin = false;

	@Output() integritySelected = new EventEmitter<ArtTreatmentIntegrity>();
	@Output() definitionSelected = new EventEmitter<ArtTreatmentDefinition>();

	onIntegrityClicked(integrity: ArtTreatmentIntegrity): void {
		if (!this.disabled) {
			this.integritySelected.emit(integrity);
		}
	}

	onDefinitionClicked(definition: ArtTreatmentDefinition): void {
		if (!this.disabled) {
			this.definitionSelected.emit(definition);
		}
	}

	integrityTrackBy(index: number, integrity: ArtTreatmentIntegrity): number {
		return integrity;
	}

	definitionTrackBy(index: number, definition: ArtTreatmentDefinition): number {
		return definition;
	}

	isIntegrityDisabled(integrity: ArtTreatmentIntegrity): boolean {
		return !this.asLabel && (this.disabled || !this.enabledIntegrities.includes(integrity));
	}

	isDefinitionDisabled(definition: ArtTreatmentDefinition): boolean {
		return !this.asLabel && (this.disabled || !this.enabledDefinitions.includes(definition));
	}
}
